module.exports = __webpack_public_path__ + "02_glasses_black.d50fbbcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer4/02_glasses_black.png
// module id = Ik5i
// module chunks = 0